import { deleteAttribute } from './deleteAttribute';
import { saveAttribute } from './saveAttribute';

// actionName と function のマッピング
export const programOptionCallMap = {
  deleteAttribute: deleteAttribute,
  saveAttribute: saveAttribute,
};
